import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Button from '../SelectValue/Button';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import getServices from '../../Services/get-service';
import swal from 'sweetalert';
import { format, parseISO } from 'date-fns';
import Loading from '../SelectValue/Loading';
import Constant from '../../Constant';
import Checkbox from '@mui/material/Checkbox';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import avatar from '../../Assets/images/avatar.png';
import inflow from '../../Assets/images/inflow.png';
import outflow from '../../Assets/images/outflow.png';
import Constants from '../../Constant';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#D5C1FB',
    color: '#14013A',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function TransactionTableMain() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [transactionType, setTransactionType] = useState('');
  const [transactionStatus, setTransactionStatus] = useState(''); 
  const [loading, setLoading] = useState(false);
  const currentDate = new Date();
  const oneWeekAgo = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
  const [fromDate, setFromDate] = useState(oneWeekAgo);
  const [toDate, setToDate] = useState(currentDate);
  const [allInvestment, setAllInvestment] = useState([]);
  const [countData, setCountData] = useState([]);

  const isDateValid = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date <= today;
  };

  const filteredTransactions = allInvestment.filter((transaction) => {
    const matchesType = !transactionType || transaction.transType === transactionType;
    const normalizedStatus = transaction.status === 'success' ? 'Success' : 'Failed';
    const matchesStatus = !transactionStatus || normalizedStatus === transactionStatus;
    return matchesType && matchesStatus;
  });

  useEffect(() => {
    const newTodate = toDate.toISOString();
    const newFromdate = fromDate.toISOString();
    setLoading(true);
    getServices.getAllTransaction(newFromdate, newTodate).then(
      (response) => {
        setLoading(false);
        if (response.data.status === '2000') {
          console.log('my investments ', response.data.data);
          setAllInvestment(response.data.data);
        } else {
          swal(response.data.description);
        }
      },
      (error) => {
        setLoading(false);
      }
    );
  }, [fromDate, toDate]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getServices.getAllCount(
          new Date().toISOString().split('T')[0],
          new Date().toISOString().split('T')[0]
        );
        if (response.data.status === '2000') {
          console.log('Count Data:', response.data.data);
          setCountData(response.data.data);
        } else {
          console.log('Something went wrong:', response.data.description);
        }
      } catch (error) {
        console.log('Error getting data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (page < Math.ceil(filteredTransactions.length / rowsPerPage) - 1) {
      setPage(page + 1);
    }
  };

  useEffect(() => {
    setPage(0);
  }, [transactionType, transactionStatus, fromDate, toDate]);

  return (
    <>
      <Loading open={loading} />

      <div className="my-8 flex flex-wrap items-center gap-4">
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-4">
          <div className="w-full sm:w-auto lg:col-span-2">
            <input
              placeholder="Search by name or email address"
              className="border border-gray-300 focus:border-primary-color outline-none p-2 rounded w-full"
            />
          </div>
          <div className="w-full sm:w-auto">
            <select
              className="border w-full p-3 focus:border-primary-color rounded"
              value={transactionType}
              onChange={(e) => setTransactionType(e.target.value)}
            >
              <option value=""> Transaction Type</option>
              <option value="Credit">Credit</option>
              <option value="Debit">Debit</option>
            </select>
          </div>
          <div className="w-full sm:w-auto">
            <select
              className="border w-full p-3 focus:border-primary-color rounded"
              value={transactionStatus}
              onChange={(e) => setTransactionStatus(e.target.value)}
            >
              <option value="">Status</option>
              <option value="Success">Success</option>
              <option value="Failed">Failed</option>
            </select>
          </div>
          <div className="w-full sm:w-auto flex gap-2 items-center">
            <p className="mb-2 pt-1">From:</p>
            <DatePicker
              className="border w-full p-3 focus:border-primary-color rounded"
              selected={fromDate}
              onChange={(date) => setFromDate(date)}
              maxDate={new Date()}
              filterDate={isDateValid}
              popperPlacement="top-end"
            />
          </div>
          <div className="w-full sm:w-auto flex gap-2 items-center">
            <p className="mb-2 pt-1">To:</p>
            <DatePicker
              className="border w-full p-3 focus:border-primary-color rounded"
              selected={toDate}
              onChange={(date) => setToDate(date)}
              maxDate={new Date()}
              filterDate={isDateValid}
              popperPlacement="top-end"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 my-5">
        <div className="border-2 rounded-lg border-gray-200 p-3 lg:col-span-2">
          <img src={avatar} className="w-6 h-6" alt="avatar" />
          <p className="text-sm font-semibold text-gray-600">Total customers</p>
          <p className="text-sm font-semibold text-gray-900">
            {parseInt(countData.activeUsers ?? 0) + parseInt(countData.nonActiveUsers ?? 0) ?? 0}
          </p>
        </div>
        <div className="border-2 rounded-lg border-gray-200 p-3 lg:col-span-2">
          <img src={inflow} className="w-6 h-6" alt="inflow" />
          <p className="text-sm font-semibold text-gray-600">Total inflow</p>
          <p className="text-sm font-semibold text-gray-900">
            NGN {Constants.FormatNumber(countData.totalInflow ?? 0)}
          </p>
        </div>
        <div className="border-2 rounded-lg border-gray-200 p-3 lg:col-span-2">
          <img src={outflow} className="w-6 h-6" alt="outflow" />
          <p className="text-sm font-semibold text-gray-600">Total outflow</p>
          <p className="text-sm font-semibold text-gray-900">
            NGN {Constants.FormatNumber(countData.totalOutflow ?? 0)}
          </p>
        </div>
      </div>

      <div className="mt-16">
        <div className="hidden md:flex flex-row justify-between items-center bg-primary-bg rounded-t-md rounded-r-md border-primary-border border p-4">
          <Checkbox />
          <p className="text-text flex-1 text-center whitespace-normal break-words">User</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Transaction Type</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Amount</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Date</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Status</p>
        </div>

        {loading ? (
          <div>
            {[...Array(rowsPerPage)].map((_, index) => (
              <div
                key={index}
                className="flex flex-col md:flex-row justify-between items-start md:items-center bg-white border-b border-gray-200 p-4 gap-2"
              >
                <div className="w-6 md:w-[5%]">
                  <Skeleton width={24} height={24} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="80%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
              </div>
            ))}
          </div>
        ) : Array.isArray(filteredTransactions) && filteredTransactions.length > 0 ? (
          <>
            <div className="md:hidden">
              {filteredTransactions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((investment, index) => (
                <div
                  key={index}
                  className="border rounded-lg p-4 mb-3 bg-white shadow-sm"
                >
                  <p className="font-semibold">{investment.beneficiaryUsername || investment.senderUsername || 'N/A'}</p>
                  <p>
                    <b>Transaction Type:</b>{' '}
                    <span
                      className={`inline-block px-2 py-1 rounded-full text-sm font-medium ${
                        investment.transType === 'Credit' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}
                    >
                      {investment.transType || 'N/A'}
                    </span>
                  </p>
                  <p><b>Amount:</b> NGN {Constant.FormatNumber(investment.amount ?? 0)}</p>
                  <p><b>Date:</b> {investment.createdDate ? format(parseISO(investment.createdDate), 'MMM d yyyy') : 'N/A'}</p>
                  <p>
                    <b>Status:</b>{' '}
                    <span
                      className={`inline-block px-2 py-1 rounded-full text-sm font-medium ${
                        investment.status === 'success' ? ' text-emerald-500' : ' text-rose-500'
                      }`}
                    >
                      {investment.status === 'success' ? 'Success' : 'Failed'}
                    </span>
                  </p>
                </div>
              ))}
            </div>
            <div className="hidden md:block">
              {filteredTransactions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((investment, index) => (
                <div
                  key={index}
                  className="flex flex-row justify-between items-center bg-white border-b border-gray-200 p-4"
                >
                  <Checkbox />
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    {investment.beneficiaryUsername || investment.senderUsername || 'N/A'}
                  </p>
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    <span
                      className={`inline-block px-2 py-1 rounded-full text-sm font-medium ${
                        investment.transType === 'Credit' ? ' text-emerald-500' : ' text-rose-500'
                      }`}
                    >
                      {investment.transType || 'N/A'}
                    </span>
                  </p>
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    NGN {Constant.FormatNumber(investment.amount ?? 0)}
                  </p>
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    {investment.createdDate ? format(parseISO(investment.createdDate), 'MMM d yyyy') : 'N/A'}
                  </p>
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    <span
                      className={`inline-block px-2 py-1 rounded-full text-sm font-medium ${
                        investment.status === 'success' ? ' text-emerald-500' : ' text-rose-500'
                      }`}
                    >
                      {investment.status === 'success' ? 'Success' : 'Failed'}
                    </span>
                  </p>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="text-center p-4 text-gray-500">
            No Transactions found
          </div>
        )}

        {Array.isArray(filteredTransactions) && filteredTransactions.length > rowsPerPage && (
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mt-4 mb-10">
            <button
              onClick={handlePreviousPage}
              disabled={page === 0}
              className={`px-4 py-2 rounded-lg ${
                page === 0 ? 'bg-gray-300 cursor-not-allowed' : 'bg-primary-color text-white hover:bg-primary-color-dark'
              }`}
            >
              Previous
            </button>
            <p className="text-text text-sm sm:text-base">
              Page {page + 1} of {Math.ceil(filteredTransactions.length / rowsPerPage)}
            </p>
            <button
              onClick={handleNextPage}
              disabled={page >= Math.ceil(filteredTransactions.length / rowsPerPage) - 1}
              className={`px-4 py-2 rounded-lg ${
                page >= Math.ceil(filteredTransactions.length / rowsPerPage) - 1
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'bg-primary-color text-white hover:bg-primary-color-dark'
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </>
  );
}